import type { IconData } from '@stacksjs/iconify-core'

export const codingAppsWebsitesConference: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M1.52 24.38h28.95v1.52H32v-3.04h-3.05V6.09h-1.53v16.77H25.9v-1.53h-1.52v1.53h-9.15v-1.53h-1.52v1.53h-1.52V6.09h15.23V4.57H4.57v1.52h6.09v6.1H4.57v-6.1H3.04v16.77H0v3.04h1.52Zm3.05-9.14h6.09v6.09H4.57ZM1.52 25.9h28.95v1.53H1.52Z\"/><path fill=\"currentColor\" d=\"M21.33 19.81h3.05v1.52h-3.05Zm0-3.05h1.52v1.52h-1.52Z\"/><path fill=\"currentColor\" d=\"M18.28 18.28h3.05v1.53h-3.05Zm-3.05 1.53h3.05v1.52h-3.05Zm1.53-3.05h1.52v1.52h-1.52Zm6.09-3.05v3.05h1.53v-4.57h-1.53v-1.53h-1.52V9.14h-3.05v1.52h-1.52v1.53h-1.53v4.57h1.53v-3.05zM6.09 18.28h3.05v1.53H6.09Zm0-9.14h3.05v1.52H6.09Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default codingAppsWebsitesConference
